import React, {useEffect, useRef, useMemo} from 'react'
import EStyleSheet from "react-native-extended-stylesheet";
import {View} from "react-native";

const MessageHtmlFrame = ({html, showImages = false, expandToFullHeight = false, isDarkMode = false}) => {
    console.log('[MessageHtmlFrame] Render - expandToFullHeight:', expandToFullHeight, typeof expandToFullHeight);
    const ref = useRef(null);
    const containerRef = useRef(null);
    const originalHtmlRef = useRef(html);

    // Update original HTML ref when html prop changes
    useEffect(() => {
        originalHtmlRef.current = html;
    }, [html]);

    // Process HTML to remove images when showImages is false
    const processedHtml = useMemo(() => {
        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Modify anchor tags to open links in a new tab with rel no referrer
            const anchors = doc.querySelectorAll('a');
            anchors.forEach(anchor => {
                anchor.setAttribute('target', '_blank');
                anchor.setAttribute('rel', 'noreferrer');
            });

            if (showImages || !html) {
                return doc.documentElement.outerHTML;
            }

            // Remove src and srcset attributes from img
            const images = doc.querySelectorAll('img');
            images.forEach(img => {
                img.removeAttribute('src');
                img.removeAttribute('srcset');
            });

            // Remove background-image from inline styles
            const allElements = doc.querySelectorAll('*');
            allElements.forEach(el => {
                if (el.hasAttribute('style')) {
                    const style = el.getAttribute('style');
                    const updatedStyle = style.replace(/background-image\s*:\s*[^;]+;?/gi, '');
                    if (updatedStyle.trim()) {
                        el.setAttribute('style', updatedStyle.trim());
                    } else {
                        el.removeAttribute('style');
                    }
                }
            });

            // Remove background-image from style tags
            const styleTags = doc.querySelectorAll('style');
            styleTags.forEach(styleTag => {
                const css = styleTag.innerHTML;
                const updatedCss = css.replace(/background-image\s*:\s*[^;]+;?/gi, '');
                styleTag.innerHTML = updatedCss;
            });

            return doc.documentElement.outerHTML;
        } catch (e) {
            console.error('Error processing HTML:', e);
            return html;
        }
    }, [html, showImages]);

    useEffect(() => {
        if (ref.current) {
            const iframeDoc = ref.current.contentDocument;

            if (iframeDoc) {
                const style = iframeDoc.createElement('style');
                style.innerHTML = `
                    body {
                        margin: 0;
                        padding: 0;
                        ${expandToFullHeight ? 'height: 100vh;' : ''}
                    }
                    html {
                        ${expandToFullHeight ? 'height: 100%;' : ''}
                    }
                `;
                iframeDoc.head.appendChild(style);
            }
        }
    }, [expandToFullHeight]);

    const containerStyle = [
        styles.container,
        expandToFullHeight && styles.containerExpanded,
        {marginTop: expandToFullHeight ? 0 : 5, borderRadius: 6, overflow: 'hidden'},
        isDarkMode && {
            backgroundColor: '#FFFFFF',
        },
    ];
    const iframeStyle = {
        width: '100%',
        minHeight: expandToFullHeight ? '100%' : 200,
        height: expandToFullHeight ? '100%' : 'auto',
        border: 'none',
        flex: expandToFullHeight ? 1 : undefined,
    };

    return (
        <View ref={containerRef} style={containerStyle}>
            <iframe
                ref={ref}
                sandbox="allow-popups allow-popups-to-escape-sandbox"
                referrerPolicy="no-referrer"
                srcDoc={processedHtml}
                style={iframeStyle}
            ></iframe>
        </View>
    )
}

const styles = EStyleSheet.create({
    container: {
        width: '100%',
        flex: 1,
    },
    containerExpanded: {
        flex: 1,
        minHeight: 0,
    }
})

export default MessageHtmlFrame